import { render, staticRenderFns } from "./navBottom.vue?vue&type=template&id=437e5a29&scoped=true&"
import script from "./navBottom.vue?vue&type=script&lang=js&"
export * from "./navBottom.vue?vue&type=script&lang=js&"
import style0 from "./navBottom.vue?vue&type=style&index=0&id=437e5a29&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437e5a29",
  null
  
)

export default component.exports